import script from "./ProfileImage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileImage.vue?vue&type=script&setup=true&lang=js"

import "./ProfileImage.vue?vue&type=style&index=0&id=502f4bc7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-502f4bc7"]])

export default __exports__